import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-iniciar-conversacion',
  templateUrl: './iniciar-conversacion.component.html',
  styleUrls: ['./iniciar-conversacion.component.css']
})
export class IniciarConversacionComponent {
  mensajeForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<IniciarConversacionComponent>,
    private fb: FormBuilder,
    private dataService: DataService
  ) {
    // Inicializar el formulario reactivo
    this.mensajeForm = this.fb.group({
      mensaje: ['', [Validators.required, Validators.minLength(1)]]
    });
  }

  enviarMensaje(): void {
    if (this.mensajeForm.invalid) {
      return;
    }

    const payload = {
      destinatarioId: this.data.ejecutivo.id,
      solicitudId: this.data.solicitudId,
      contenido: this.mensajeForm.value.mensaje
    };

    this.dataService.postData(payload, 'mensajes', environment.apiMensajeUrl).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: () => {
        alert('Ocurrió un error al enviar el mensaje.');
      }
    });
  }
}
